// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.List__container___NL2so {
    display: flex;
    flex-direction: column;
    gap: var(--space-xs);
}

.List__itemWrapper___ls87j {
    list-style: none;
}

.List__item___fCaSu {
    --primary-display: inline;
    --secondary-display: none;

    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;

    display: grid;
    grid-template: 'icon name right' / min-content auto auto;
    gap: var(--space-xs);
    align-items: center;

    max-width: 100%;
    height: 3.2rem;
    padding: var(--space-2xs) var(--space-xs);

    font-size: var(--size-text-xs);
    color: var(--color-typo-primary);

    border-radius: var(--space-2xs);

    &:hover {
        --primary-display: none;
        --secondary-display: inline-flex;

        background-color: var(--color-bg-secondary);
    }

    & .List__icon___bfD90 {
        grid-area: icon;
    }

    & .List__name___HNVnU {
        overflow: hidden;
        grid-area: name;
        text-overflow: ellipsis;
        text-wrap: nowrap;
    }

    & .List__right___nvCpF {
        display: flex;
        grid-area: right;
        flex-direction: row;
        gap: var(--space-xs);
        align-items: center;
        justify-content: flex-end;

        min-height: 0;

        & .List__primary___rxpzF,
        .List__secondary___RcVBI {
            gap: var(--space-xs);
        }

        & .List__primary___rxpzF {
            display: var(--primary-display);
            color: var(--color-typo-secondary);
        }

        & .List__secondary___RcVBI {
            display: var(--secondary-display);
        }
    }
}

.List__itemWrapper___ls87j[aria-selected='true'] .List__item___fCaSu {
    color: var(--color-control-typo-secondary);
    list-style: none;
    border: 0.1rem solid var(--color-control-bg-primary);
}

.List__createAction___pxvBq {
    color: var(--color-control-typo-secondary);
    background-color: var(--color-bg-ghost);
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/List/List.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;;IAEzB,eAAe;IACf,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;;IAEjB,aAAa;IACb,wDAAwD;IACxD,oBAAoB;IACpB,mBAAmB;;IAEnB,eAAe;IACf,cAAc;IACd,yCAAyC;;IAEzC,8BAA8B;IAC9B,gCAAgC;;IAEhC,+BAA+B;;IAE/B;QACI,uBAAuB;QACvB,gCAAgC;;QAEhC,2CAA2C;IAC/C;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,uBAAuB;QACvB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,oBAAoB;QACpB,mBAAmB;QACnB,yBAAyB;;QAEzB,aAAa;;QAEb;;YAEI,oBAAoB;QACxB;;QAEA;YACI,+BAA+B;YAC/B,kCAAkC;QACtC;;QAEA;YACI,iCAAiC;QACrC;IACJ;AACJ;;AAEA;IACI,0CAA0C;IAC1C,gBAAgB;IAChB,oDAAoD;AACxD;;AAEA;IACI,0CAA0C;IAC1C,uCAAuC;AAC3C","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-xs);\n}\n\n.itemWrapper {\n    list-style: none;\n}\n\n.item {\n    --primary-display: inline;\n    --secondary-display: none;\n\n    cursor: pointer;\n    user-select: none;\n\n    display: grid;\n    grid-template: 'icon name right' / min-content auto auto;\n    gap: var(--space-xs);\n    align-items: center;\n\n    max-width: 100%;\n    height: 3.2rem;\n    padding: var(--space-2xs) var(--space-xs);\n\n    font-size: var(--size-text-xs);\n    color: var(--color-typo-primary);\n\n    border-radius: var(--space-2xs);\n\n    &:hover {\n        --primary-display: none;\n        --secondary-display: inline-flex;\n\n        background-color: var(--color-bg-secondary);\n    }\n\n    & .icon {\n        grid-area: icon;\n    }\n\n    & .name {\n        overflow: hidden;\n        grid-area: name;\n        text-overflow: ellipsis;\n        text-wrap: nowrap;\n    }\n\n    & .right {\n        display: flex;\n        grid-area: right;\n        flex-direction: row;\n        gap: var(--space-xs);\n        align-items: center;\n        justify-content: flex-end;\n\n        min-height: 0;\n\n        & .primary,\n        .secondary {\n            gap: var(--space-xs);\n        }\n\n        & .primary {\n            display: var(--primary-display);\n            color: var(--color-typo-secondary);\n        }\n\n        & .secondary {\n            display: var(--secondary-display);\n        }\n    }\n}\n\n.itemWrapper[aria-selected='true'] .item {\n    color: var(--color-control-typo-secondary);\n    list-style: none;\n    border: 0.1rem solid var(--color-control-bg-primary);\n}\n\n.createAction {\n    color: var(--color-control-typo-secondary);\n    background-color: var(--color-bg-ghost);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `List__container___NL2so`,
	"itemWrapper": `List__itemWrapper___ls87j`,
	"item": `List__item___fCaSu`,
	"icon": `List__icon___bfD90`,
	"name": `List__name___HNVnU`,
	"right": `List__right___nvCpF`,
	"primary": `List__primary___rxpzF`,
	"secondary": `List__secondary___RcVBI`,
	"createAction": `List__createAction___pxvBq`
};
export default ___CSS_LOADER_EXPORT___;
